import React, {FC, useEffect} from 'react';

import loadable from '@loadable/component';
import {getCurrentScope} from '@sentry/react';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {Provider} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {Store} from 'redux';

import {apiConfig} from 'libs/api/api';
import {polyfillRequestIdleCallback} from 'libs/polyfills/requestIdleCallback';
import {ApiConfigType} from 'types/types';

import {HostStoreContext} from '../hooks/hostHooks/hostHooks';

import RoutesWrapper from './routesWrapper';
import {sagaMiddleware} from './store';

const DesktopMiniCart = loadable(() => import('desktopMiniCart'), {
    resolveComponent: components => components.default,
});

type PropsType = {
    apiConfigData: ApiConfigType;
    hostStore: Store;
    isMiniCart: boolean;
    skeleton: React.ReactNode;
};

const queryClient = new QueryClient();

polyfillRequestIdleCallback();

/**
 * Desktop Checkout MFE Page
 */
const DesktopCheckoutMFE: FC<PropsType> = ({
    apiConfigData,
    hostStore,
    isMiniCart = false,
    skeleton = null,
}) => {
    if (__BUILD_TYPE__ === 'mobile') return null;
    // because of dead code elimination
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const navigate = useNavigate();
    apiConfig.API_URL = apiConfigData.API_URL;
    apiConfig.instanceGusaBackend = apiConfigData.instanceGusaBackend;
    apiConfig.instanceDyChoose = apiConfigData.instanceDyChoose;
    apiConfig.instanceDyEngagement = apiConfigData.instanceDyEngagement;
    apiConfig.instancePopupBackend = apiConfigData.instancePopupBackend;

    apiConfig.hostStore = hostStore;

    // because of dead code elimination
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        const scope = getCurrentScope();
        scope.setTag('platform', 'desktop');
        sagaMiddleware.setContext({navigate});
    }, [navigate]);

    return (
        <QueryClientProvider client={queryClient}>
            <Provider context={HostStoreContext} store={hostStore}>
                {isMiniCart ? <DesktopMiniCart /> : <RoutesWrapper skeleton={skeleton} />}
            </Provider>
        </QueryClientProvider>
    );
};

export default DesktopCheckoutMFE;
